/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { useEffect, useState } from "react";

import { EmbedIdentifier } from "src/classes/block/block-types";
import { YoutubeFacade } from "src/components/Block/BlockTypes/LinkBlock/Youtube/YoutubeFacade";

interface Props {
  youtubeId: string;
  disableMouse: boolean;
}

export const YoutubeEmbed = ({ youtubeId, disableMouse }: Props) => {
  const [title, setTitle] = useState("");

  useEffect(() => {
    EmbedIdentifier.getYoutubeTitleFromId(youtubeId).then((res) => {
      setTitle(res);
    });
  }, [youtubeId]);

  return <YoutubeFacade id={youtubeId} title={title} disableMouse={disableMouse} />;
};
